import React, { Fragment, useEffect, useState } from "react";
import {
    Button,
    Input,
    InputGroup,
    ListGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from "reactstrap";
import { GetCookieToken } from "../../Cookie/GetCookie";
import axios from "axios";
import { useInsertConText } from "../../Context/InsertContext";
import LoadingData from "../../TESTPage/LoadingData";

const API_URL = process.env.REACT_APP_API_CORS;

function ModalUser(props) {
    const { task, showSelectedAllMenu = false, disbleButton = false, defaultValue = "ทั้งหมด", alowUserSpecial = false } = props;
    const { insert, setInsert } = useInsertConText();
    const token = GetCookieToken("userToken");
    const [modal, setModal] = useState(false);
    const [data, setData] = useState([]);
    const [activeItem, setActiveItem] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [enterKeyword, setEnterKeyword] = useState("");
    const [dataInfo, setDataInfo] = useState([]);
    const [insert_id, setInsert_id] = useState();
    const [insert_name, setInsert_name] = useState();
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true)
        const url = `${API_URL}/api/users/datatable`;
        const fetchData = () => {
            const params = new URLSearchParams({
                page: currentPage,
                size: pageSize,
                "order[0]": "user_name",
                "order[1]": "ASC",
                "filter[user_name_status][0]": "ปกติ",
                "filter[user_outsider][0]": 0,
                "filter[user_special][0]": 0,
                search: enterKeyword,
            });
            if (alowUserSpecial) {
                params.delete("filter[user_special][0]", 0)
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            };
            axios
                .get(url, config)
                .then(response => {
                    setData(() => response.data.result);
                    setDataInfo(() => response.data.info);
                    setTotalPages(Math.ceil(response.data.info.totalRows / pageSize));
                })
                .catch(error => console.error("Error:", error));
            setTimeout(() => {
                setLoading(false)
            }, 1500);
        };
        fetchData();
    }, [enterKeyword]);

    const handleListItemClick = (id, e, value) => {
        setActiveItem(id === activeItem ? null : id);
        setInsert_id(id);
        setInsert_name(e);
    };

    const toggle = () => setModal(!modal);

    const handleFinalClick = () => {
        setInsert({ insert_id, insert_name, task });
    };

    const handleClearClick = () => {
        setActiveItem(null);
    };

    const handleSearch = () => {
        setEnterKeyword(searchTerm)
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
        }
    };


    return (
        <Fragment>
            <Button color="secondary" disabled={disbleButton} onClick={toggle}>
                <i className="fa-solid fa-list"></i>
            </Button>
            <Modal isOpen={modal} toggle={toggle} centered size="md">
                <ModalHeader
                    toggle={() => {
                        toggle();
                        handleClearClick();
                    }}
                >
                    เลือกเจ้าหน้าที่
                </ModalHeader>
                <ModalBody>
                    {/* <Input
            className="w-100"
            placeholder="ค้นหา"
            type="search"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          /> */}
                    <InputGroup>
                        <Input
                            placeholder="ค้นหา"
                            type="search"
                            value={searchTerm}
                            onChange={e => {
                                setSearchTerm(e.target.value)
                            }}
                            onKeyDown={handleKeyDown}
                            onKeyUp={e => {
                                setTimeout(() => {
                                    handleSearch()
                                }, 200);
                            }}
                        />
                        {/* <Button onClick={handleSearch}>
                            <i className="fa-solid fa-magnifying-glass p-1"></i>
                        </Button> */}
                        <Button color="danger" onClick={e => {
                            setSearchTerm('')
                        }}>
                            <i className="fa-solid fa-magnifying-glass-minus p-1"></i>
                        </Button>
                    </InputGroup>

                    <div className="pt-3">
                        {!showSelectedAllMenu &&
                            <Fragment >
                                <ListGroup className="mb-2">
                                    <Input
                                        readOnly
                                        className="border rounded-0"
                                        defaultValue={defaultValue}
                                        onClick={() =>
                                            handleListItemClick(null, defaultValue)
                                        }
                                        valid={null === activeItem}
                                        style={{
                                            cursor: "pointer",
                                            transition: "background-color 0.3s",
                                        }}
                                    />
                                </ListGroup>
                            </Fragment>
                        }
                        {
                            loading ?
                                <LoadingData />
                                : data.length > 0 ?
                                    data.map((user, index) => (
                                        <Fragment key={index}>
                                            <ListGroup key={user.user_id}>
                                                <Input
                                                    readOnly
                                                    className="border rounded-0"
                                                    defaultValue={user.user_name}
                                                    onClick={() =>
                                                        handleListItemClick(user.user_id, user.user_name)
                                                    }
                                                    valid={user.user_id === activeItem}
                                                    style={{
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                />
                                            </ListGroup>
                                        </Fragment>
                                    ))
                                    : <div className="d-flex justify-content-center">ไม่พบข้อมูล</div>
                        }</div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={() => {
                            toggle();
                            handleFinalClick();
                        }}
                    >
                        ตกลง
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => {
                            toggle();
                            handleClearClick();
                        }}
                    >
                        ยกเลิก
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

export default ModalUser;
